export const locale = {
    lang: 'ru',
    data: {
        'QUICK_PANNEL': {
            'NOTIFICATIONS': 'Уведомления',
            'NEW_EMAIL_FROM': 'Новый email от',
            'DATE': 'Дата',
            'SUBJECT': 'Тема',
            'NEW_TICKET': 'Новый тикет',
            'NEW_ASSIGNED_TICKET': 'Новый назначенный тикет',
            'NEW_TICKET_MESSAGE': 'Новое сообщение к тикету',
            'MESSAGE': 'Сообщение',
            'NEW_ASSIGNED_EVENT': 'Новое назначенное событие',
            'CREATOR': 'Создал(а)',
            'TYPE': 'Тип',
            'CLIENT': 'Клиент',
            'LEAD': 'Лид',
            'NEW_DOC_FROM': 'Новый документ от',
            'DOC_TYPE': 'Тип документа',
            'NEW_UPCOMING_EVENT': 'Новое предстоящее событие',
            'ADD_PAYMENT_METHOD': 'добавил(а) новый способ оплаты',
            'METHOD_TYPE': 'Метод отплаты',
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/main/quick-panel/i18n/ru.ts